function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.20712 9.79289C5.81659 9.40237 5.18343 9.40237 4.7929 9.79289C4.40238 10.1834 4.40238 10.8166 4.7929 11.2071L6.20712 9.79289ZM8.50001 13.5L7.7929 14.2071C8.00075 14.415 8.28954 14.5208 8.58249 14.4966C8.87544 14.4723 9.14288 14.3204 9.31374 14.0812L8.50001 13.5ZM14.3137 7.08124C14.6347 6.63183 14.5307 6.00728 14.0812 5.68627C13.6318 5.36526 13.0073 5.46935 12.6863 5.91876L14.3137 7.08124ZM4.7929 11.2071L7.7929 14.2071L9.20711 12.7929L6.20712 9.79289L4.7929 11.2071ZM12.6863 5.91876L7.68627 12.9188L9.31374 14.0812L14.3137 7.08124L12.6863 5.91876Z",
  stroke: "none"
});
const Svg19Px = ({
  svgRef,
  title,
  ...props
}) => React.createElement("svg", _extends({
  width: 19,
  height: 19,
  viewBox: "0 0 19 19",
  fill: "none",
  ref: svgRef
}, props), title ? React.createElement("title", null, title) : null, _ref);
const ForwardRef = React.forwardRef((props, ref) => React.createElement(Svg19Px, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/19px.8d1c8bfc.svg";
export { ForwardRef as ReactComponent };